import {FC} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {ButtonLink} from '@components/commons/button-link'
import {routes} from '@utilities/constants/routes.tsx'

/** Where the opt-in flow was entered from, used to route "back" on completion. */
export type FloorPlanOptInOrigin = 'home' | 'settings'

interface FloorPlanOptInButtonProps {
    /** Entry point, forwarded as router state so the completed step can route back. */
    from: FloorPlanOptInOrigin
}

/**
 * Opt-in CTA shared by the home banner and the settings section: navigates to
 * the private opt-in form (`/floor-plan/opt-in`).
 */
export const FloorPlanOptInButton: FC<FloorPlanOptInButtonProps> = ({from}) => {
    const {t} = useTranslation()

    return (
        <ButtonLink to={routes.FLOOR_PLAN_OPT_IN.handle.fullPath} state={{from}} variant="primary">
            {t('floor_plan:banner:opt_in')}
        </ButtonLink>
    )
}
